import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/home/page";
import NewsListPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail";
import RecommendationsPage from "@/pages/recommendations/page";
import MovieDetailPage from "@/pages/movies/detail";
import VarietyPage from "@/pages/variety/page";
import VarietyDetailPage from "@/pages/variety/detail";
import CommunityPage from "@/pages/community/page";
import PostDetailPage from "@/pages/community/detail";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "recommendations", element: <RecommendationsPage /> },
      { path: "movies/:id", element: <MovieDetailPage /> },
      { path: "variety", element: <VarietyPage /> },
      { path: "variety/:id", element: <VarietyDetailPage /> },
      { path: "community", element: <CommunityPage /> },
      { path: "community/:id", element: <PostDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;